import type { VaultItemType } from './index';

/**
 * The Binder item types — contacts, documents, schedules, and lists. These live
 * in the family Binder (and, for contacts, the personal My Contacts surface), NOT
 * the Safe / login list. The Safe surfaces (personal safe list, family Sites pane)
 * exclude them so they only appear in the Binder. Cross-client parity with
 * Android's `SafeListFilters.NON_SAFE_TYPES` and iOS's `nonSafeTypes`.
 */
export function isBinderType(type: VaultItemType | undefined): boolean {
  return type === 'contact' || type === 'document' || type === 'schedule'
    || type === 'list';
}
